import React, { useEffect, useState } from 'react'
import * as styles from './tooltip.module.scss'
import parse from 'html-react-parser'
import translate from '../../helpers/Translate'

export const RatingTooltip = ({ 
    product, 
    rating, 
    type, 
    valueType, 
    zIndex, 
    dynamicLabel1, 
    dynamicLabel2,
    isRoundup 
}) => {

    let descriptionText = {
        text1 : '', text2 : ''
    }

    let ratingRes, label

    let descriptions = {
        design : {
            text1 : translate(`The design rating takes into account the shape of the toy in both a visual and ergonomic perspective. We ask our reviewers to rate the overall feeling of the ${dynamicLabel1}.`, dynamicLabel1),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) +  ` ${ratingRes}.`,
            d1 : translate('is terribly designed'),
            d2 : translate('is designed ok'),
            d3 : translate('is designed well'),
            d4 : translate('is designed very well'),
            d5 : translate('is designed absolutely incredible')
        },
        easeOfUse : {
            text1 : translate('The Ease of Use rating is a score given on how easy the toy is to operate and use. Aspects that are considered is the suitability for different kinds of people, intuitiveness, and potential learning curve of using the product for pleasure (or pain).'),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is very hard to use'),
            d2 : translate('is possible to figure out how it should be used'),
            d3 : translate('is somewhat intuitive and easy to use'),
            d4 : translate('is very easy to figure out and use'),
            d5 : translate('is extremely easy to use and worked very well')
        },
        quality : {
            text1 : translate('The Quality rating is a score that takes into account the quality of the materials used in the toy, how well it was manufactured, the safety, durability and overall quality feel of the toy.'),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is of very poor quality'),
            d2 : translate('is of mediocre quality'),
            d3 : translate('is fairly good quality'),
            d4 : translate('is very good quality'),
            d5 : translate('is one of the absolute top quality toys')
        },
        price : {
            text1 : translate('The Price rating is indicated by 1-5 price icons. 1 indicate a very cheap product, while 5 indicate a very expensive product. The rating is a relative score compared to other similar toys.'),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) +  ` ${ratingRes}.`,
            // d1 : translate('is very cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            // d2 : translate('is cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            // d3 : translate('is priced in the middle'),
            // d4 : translate('neither expensive nor cheap'),
            // d5 : translate('is very expensive')
            d1 : translate('is cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            d2 : translate('is affordable compared to other ' + dynamicLabel2, dynamicLabel2),
            d3 : translate('is moderately priced, neither expensive nor cheap'),
            d4 : translate('is pricier than the rest, but not the most expensive'),
            d5 : translate('is in the premium price range')
        },
        siteRating : {
            text1 : translate(`The Bedbible rating is indicated by 1-5 stars. 1 indicates a very bad product, while 5 indicate a very good product. It is the overall rating given by our tester which makes it a very subjective score of the ${product}.`, product),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is a very bad product'),
            d2 : translate('is an ok product, but the tester would advice you find an alternative'),
            d3 : translate('is a fairly good rated product, however, definitely not among the best'),
            d4 : translate('is a top tier sex toy rated amongst the best'),
            d5 : translate('is amongst the absolute best of toys that I can absolutely recommend you try out')
        },
        userRating : {
            text1 : translate('The User rating is indicated by 1-5 stars. The score is an aggregated rating of all online ratings. We find and aggregate all ratings based on a weighting system that takes into account how many reviews are available at each source.'),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is a very bad product'),
            d2 : translate('is an ok product, but the tester would advice you find an alternative'),
            d3 : translate('is a fairly good rated product, however, definitely not among the best'),
            d4 : translate('is a top tier sex toy rated amongst the best'),
            d5 : translate('is amongst the absolute best of toys that I can absolutely recommend you try out')
        } 
    }

    if( valueType === 100 ) {
        switch( true ){
            case rating <= 20:
                label = descriptions[ type ].d1
                break
            case rating > 20 && rating <= 40:
                label = descriptions[ type ].d2
                break
            case rating > 40 && rating <= 60:
                label = descriptions[ type ].d3
                break
            case rating > 60 && rating <= 80:
                label = descriptions[ type ].d4
                break
            case rating > 80:
                label = descriptions[ type ].d5
                break
            default:
                break
        }
    }

    if( valueType === 1 ) {
        switch( true ){
            case parseFloat( rating )  < 1:
                label = descriptions[ type ].d1
                break
            case  parseFloat( rating ) >= 1 &&  parseFloat( rating ) < 2:
                label = descriptions[ type ].d2
                break
            case  parseFloat( rating ) >= 2 &&  parseFloat( rating ) < 3:
                label = descriptions[ type ].d3
                break
            case  parseFloat( rating ) >= 3 &&  parseFloat( rating ) < 4:
                label = descriptions[ type ].d4
                break
            case  parseFloat( rating ) >= 4:
                label = descriptions[ type ].d5
                break
            default:
                break
        }

    }

    ratingRes = label  

    descriptions = {
        design : {
            text1 : translate(`The design rating takes into account the shape of the toy in both a visual and ergonomic perspective. We ask our reviewers to rate the overall feeling of the ${dynamicLabel1}.`, dynamicLabel1),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) +  ` ${ratingRes}.`,
            d1 : translate('is terribly designed'),
            d2 : translate('is designed ok'),
            d3 : translate('is designed well'),
            d4 : translate('is designed very well'),
            d5 : translate('is designed absolutely incredible')
        },
        easeOfUse : {
            text1 : translate('The Ease of Use rating is a score given on how easy the toy is to operate and use. Aspects that are considered is the suitability for different kinds of people, intuitiveness, and potential learning curve of using the product for pleasure (or pain).'),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is very hard to use'),
            d2 : translate('is possible to figure out how it should be used'),
            d3 : translate('is somewhat intuitive and easy to use'),
            d4 : translate('is very easy to figure out and use'),
            d5 : translate('is extremely easy to use and worked very well')
        },
        quality : {
            text1 : translate('The Quality rating is a score that takes into account the quality of the materials used in the toy, how well it was manufactured, the safety, durability and overall quality feel of the toy.'),
            text2 : translate(`${product} was rated ${rating} out of 100, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is of very poor quality'),
            d2 : translate('is of mediocre quality'),
            d3 : translate('is fairly good quality'),
            d4 : translate('is very good quality'),
            d5 : translate('is one of the absolute top quality toys')
        },
        price : {
            text1 : translate('The Price rating is indicated by 1-5 price icons. 1 indicate a very cheap product, while 5 indicate a very expensive product. The rating is a relative score compared to other similar toys.'),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) +  ` ${ratingRes}.`,
            // d1 : translate('is very cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            // d2 : translate('is cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            // d3 : translate('is priced in the middle'),
            // d4 : translate('neither expensive nor cheap'),
            // d5 : translate('is very expensive')
            d1 : translate('is cheap compared to other ' + dynamicLabel2, dynamicLabel2),
            d2 : translate('is affordable compared to other ' + dynamicLabel2, dynamicLabel2),
            d3 : translate('is moderately priced, neither expensive nor cheap'),
            d4 : translate('is pricier than the rest, but not the most expensive'),
            d5 : translate('is in the premium price range')
        },
        siteRating : {
            text1 : translate(`The Bedbible rating is indicated by 1-5 stars. 1 indicates a very bad product, while 5 indicate a very good product.`, product),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is a very bad product'),
            d2 : translate('is an ok product, but the tester would advice you find an alternative'),
            d3 : translate('is a fairly good rated product, however, definitely not among the best'),
            d4 : translate('is a top tier sex toy rated amongst the best'),
            d5 : translate('is amongst the absolute best of toys that I can absolutely recommend you try out')
        },
        userRating : {
            text1 : translate('The User rating is indicated by 1-5 stars. The score is an aggregated rating of all online ratings. We find and aggregate all ratings based on a weighting system that takes into account how many reviews are available at each source.'),
            text2 : translate(`${product} was rated ${rating} out of 5, which means it`, product, rating) + ` ${ratingRes}.`,
            d1 : translate('is a very bad product'),
            d2 : translate('is an ok product, but the tester would advice you find an alternative'),
            d3 : translate('is a fairly good rated product, however, definitely not among the best'),
            d4 : translate('is a top tier sex toy rated amongst the best'),
            d5 : translate('is amongst the absolute best of toys that I can absolutely recommend you try out')
        } 
    }
    
    descriptionText = {
        text1 : parse( descriptions[ type ].text1 ),
        text2 : parse( descriptions[ type ].text2 )
    }

    if ( isRoundup ) {
        return(
            <>
            <p><strong>Rating:&nbsp;</strong>{descriptionText.text2}</p>
            <p><strong>{translate('What it is:')}&nbsp;</strong>
                {descriptionText.text1}
            </p>
            </>
        )
    }

    return(
        <div className={`${styles.tooltip} tool`} style={{ zIndex : zIndex }}>
            <div className={`${styles.tooltip__text} t-text`}>
                <p><strong>Rating:</strong> {descriptionText.text2}</p>
                <p>
                    <strong>{translate('What it is:')}&nbsp;</strong>
                    {descriptionText.text1}
                </p>
            </div>
        </div>
    )
}



